module.exports = __webpack_public_path__ + "img/galeria-marino.9572ca46.jpg";